import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const MagicWandFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function MagicWandFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M13.538 13.953 4.372 23.12a2.47 2.47 0 0 1-3.493 0l-.007-.007a2.47 2.47 0 0 1 0-3.493l9.166-9.166 3.5 3.5ZM13.748 6.743a2.47 2.47 0 0 1 3.493 0l.007.007a2.47 2.47 0 0 1 0 3.493l-2.296 2.296-3.5-3.5 2.296-2.296ZM24 10.9h-4V8.1h4v2.8ZM23.47 2.65l-3.5 3.36-1.939-2.02 3.5-3.36 1.94 2.02ZM15.9 4h-2.8V0h2.8v4Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default MagicWandFilled;